import { type ReactNode } from "react";

import { NavigationPendingProvider } from "../feedback/navigation-pending";
import { NavigationProgress } from "../feedback/navigation-progress";
import { GlobalRequestErrorListener } from "./global-request-error-listener";
import { AccessSessionProvider } from "./access-session";
import { AuthProvider } from "./auth-provider";
import { AriaI18nProvider } from "./aria-i18n-provider";
import { LocaleProvider } from "./locale-provider";
import { ThemeProvider } from "./theme-provider";
import { ToastProvider } from "./toast-provider";

/** 组合全局主题、国际化、操作反馈、查询缓存和 Better Auth 会话 Provider。 */
export function AppProviders({ children }: { children: ReactNode }) {
  const bypassSession =
    typeof window !== "undefined" &&
    ((import.meta.env.DEV &&
      import.meta.env.NEXT_PUBLIC_TIKTOK_BULK_MOCK_URL ===
        "http://localhost:9010" &&
      /^\/mock\/tiktok-bulk\/?$/.test(window.location.pathname)) ||
      /^\/functions\/v1\/tiktok-integration\/oauth\/callback\/?$/.test(
        window.location.pathname,
      ));

  return (
    <ThemeProvider defaultTheme="dark" enableSystem>
      <LocaleProvider>
        <AriaI18nProvider>
          <ToastProvider />
          <NavigationPendingProvider>
            <NavigationProgress />
            <GlobalRequestErrorListener>
              {bypassSession ? (
                children
              ) : (
                <AuthProvider>
                  <AccessSessionProvider>{children}</AccessSessionProvider>
                </AuthProvider>
              )}
            </GlobalRequestErrorListener>
          </NavigationPendingProvider>
        </AriaI18nProvider>
      </LocaleProvider>
    </ThemeProvider>
  );
}
